const InputText = ({ id, label, type = 'text', value, onChange, error, required = false }) => {
    return (
        <div className="position-relative mb-4">
            <label htmlFor={id} className="form-label">
                {label} {required && '*'}
            </label>
            <input
                type={type}
                className={`form-control form-control-lg ${error ? 'is-invalid' : ''}`}
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                required={required}
            />
            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export default InputText;